import React from "react";

const BorderLine = () => <div className="border-line" />;

export default BorderLine;
